/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CanvasId } from "../../commons/types/CanvasId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { AccountId } from "../../commons/types/AccountId";
import { SpaceId } from "../../commons/types/SpaceId";
import { ActorId } from "../../commons/types/ActorId";
export const Canvas = core.serialization.object({
    id: CanvasId,
    namespace: core.serialization.string().optional(),
    context: core.serialization.any(),
    metadata: core.serialization.any(),
    layout: core.serialization.any(),
    environmentId: EnvironmentId,
    accountId: AccountId,
    spaceId: SpaceId,
    actorId: ActorId.optional(),
    createdById: ActorId.optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    deletedAt: core.serialization.date().optional(),
});
